module.exports = __webpack_public_path__ + "static/img/home-icon3.81fe85b9.png";